<template>
  <div class="app-right-main">
    <el-row :gutter="20" class="searchRow">
      <el-col :span="22">
        <!-- 查询框区域 -->
        <el-form
          :model="searchForm"
          size="mini"
          :inline="true"
          label-width="90px"
        >
          <el-form-item label="切换项目">
            <el-select
              v-model="searchForm.id"
              placeholder="请选择"
              style="width: 12vw"
              @change="projectChange"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="`${item.name}（${item.number}）`"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="vertical-center header-content">
      <el-button
        v-permission="'upload_ota_file'"
        size="small"
        type="primary"
        @click="uploadOtaFile"
        class="add-button"
      >
        上传OTA文件
      </el-button>
    </div>
    <div style="margin: 20px 0">
      <el-table
        v-if="!(isY007 || isY003)"
        key="tb000"
        :data="otaList"
        stripe
        size="small"
        show-overflow-tootip="true"
      >
        <el-table-column
          align="center"
          label="版本号"
          prop="version"
          min-width="160"
        >
          <template slot-scope="scope">
            <el-button
              slot="reference"
              type="text"
              @click.native.prevent="editVersion(scope.$index, otaList)"
            >
              {{ showVersion(scope.row.version) }}
            </el-button>

            <el-popover placement="right-end" width="120" trigger="click">
              <p>修改版本号</p>
              <div style="text-align: right; margin: 0">
                <el-input
                  style="margin-bottom: 10px; height: 35px"
                  v-model="submitVersionValue"
                ></el-input>
                <el-button
                  size="mini"
                  type="text"
                  @click="editVersionValue = ''"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click.native.prevent="submitVersion(scope.$index, otaList)"
                  >确定
                </el-button>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          v-for="item in this.projectConfig.OTA_LIST_HEADER"
          :prop="item.prop"
          :label="item.label"
          :key="item.prop"
        >
        </el-table-column>
        <el-table-column align="center" label="说明" prop="description">
        </el-table-column>
        <el-table-column
          align="center"
          label="设备型号"
          :formatter="formatSocType"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="是否更新"
          :formatter="formatUpdate"
        >
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-permission="'ota_download'"
              type="text"
              size="small"
              @click.native.prevent="downloadFile(scope.$index, otaList)"
              >下载
            </el-button>

            <el-button
              v-permission="'ota_del'"
              type="text"
              size="small"
              @click.native.prevent="deleteOta(scope.$index, otaList)"
              >删除
            </el-button>

            <!-- <el-button
              type="text"
              size="small"
              @click.native.prevent="sendMessage(scope.$index, otaList)"
              >通知
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <el-table
        v-if="isY007 || isY003"
        :data="otaList"
        key="tb007"
        stripe
        size="small"
        show-overflow-tootip="true"
      >
        <el-table-column align="center" label="版本号" prop="version">
          <template slot-scope="scope">
            <el-button
              slot="reference"
              type="text"
              @click.native.prevent="editVersion(scope.$index, otaList)"
            >
              {{ scope.row.version }}
            </el-button>

            <el-popover placement="right-end" width="120" trigger="click">
              <p>修改版本号</p>
              <div style="text-align: right; margin: 0">
                <el-input
                  style="margin-bottom: 10px; height: 35px"
                  v-model="submitVersionValue"
                ></el-input>
                <el-button
                  size="mini"
                  type="text"
                  @click="editVersionValue = ''"
                  >取消</el-button
                >
                <el-button
                  type="primary"
                  size="mini"
                  @click.native.prevent="submitVersion(scope.$index, otaList)"
                  >确定
                </el-button>
              </div>
            </el-popover>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="固件类型"
          :formatter="(row) => (row.otaType == 1 ? 'Manage包' : 'App包')"
        >
        </el-table-column>

        <el-table-column
          align="center"
          v-for="item in this.y007Cols"
          :prop="item.prop"
          :label="item.label"
          :key="item.prop"
        >
        </el-table-column>

        <el-table-column
          align="center"
          label="说明"
          prop="description"
        ></el-table-column>

        <el-table-column align="center" label="更新提示">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click.native.prevent="onOtaChange(scope)"
            >
              {{ formatUpdate(scope.row) }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click.native.prevent="downloadFile(scope.$index, otaList)"
              >下载
            </el-button>

            <el-button
              type="text"
              size="small"
              @click.native.prevent="deleteOta(scope.$index, otaList)"
              >删除
            </el-button>
            <!--  <el-button
              type="text"
              size="small"
              @click.native.prevent="sendMessage(scope.$index, otaList)"
              >通知
            </el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      title="添加OTA配置"
      :visible.sync="otaDialogVisible"
      @close="closeOtaDialog"
      :append-to-body="true"
    >
      <add-ota-form
        :project="project"
        :socTypeList="socTypeList"
        :dialog-visible="otaDialogVisible"
        @clickCancel="closeOtaDialog"
        @successCreateOta="successCreateOtaAction"
      ></add-ota-form>
    </el-dialog>

    <el-dialog
      title="确认变更提示？"
      :visible.sync="otaChangeVisible"
      @close="() => (otaChangeVisible = false)"
      :append-to-body="true"
    >
      <modify-ota-form
        :project="project"
        :otaInfo="otaInfo"
        @clickCancel="() => (otaChangeVisible = false)"
        @clickConfirm="modifyConfirm"
      ></modify-ota-form>
    </el-dialog>

    <el-dialog
      title="添加通知配置"
      :visible.sync="sendMessageDialogVisible"
      @close="closeOtaDialog"
    >
      <config-notify-form
        :ota-id="selectedOtaId"
        :version="selectedOtaVersion"
        :dialog-visible="sendMessageDialogVisible"
        ref="notifyForm"
        @clickCancel="closeOtaDialog"
        @successCreateNotify="successCreateNotifyAction"
      ></config-notify-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteOta,
  getOtaList,
  getOtaFileUrl,
  editOta,
} from "../../api/otaApi";
import { getProjectList } from "../../api/projectApi";
import { optionsList } from "../../api/optionsApi";
import { handleResponse } from "../../utils/response";
import AddOtaForm from "./addOTAForm";
import ModifyOtaForm from "./modifyOTAForm";
import ConfigNotifyForm from "./sendNotify";
import { Message } from "element-ui";

export default {
  name: "OtaList",
  components: {
    AddOtaForm,
    ConfigNotifyForm,
    ModifyOtaForm,
  },
  props: {
    // socTypeList: {
    //   type: Array,
    //   default: [
    //     {
    //       name: "01s",
    //       value: "0×00000001",
    //     },
    //     {
    //       name: "06s",
    //       value: "0×00000002",
    //     },
    //   ],
    // },
    // project: {
    //   type: Object,
    //   default: { id: -1 },
    // },
  },
  computed: {
    isY007() {
      return this.project?.number?.startsWith("Y007") || false;
    },

    isY003() {
      return this.project?.number?.startsWith("Y003") || false;
    },

    isY006() {
      return this.project?.deviceName == "Y006" || false;
    },

    isY001S() {
      return this.project?.deviceName == "Y001S" || false;
    },
  },
  mounted() {
    console.log("-------------ota列表界面 mounted-------------", this.project);
    // this.getOtaListByProjectId(1, 100, this.project.id);
    console.log(this.isY007);
  },
  created() {
    const id = this.$route.query.did;
    optionsList({ type: 1 }).then((res) => {
      handleResponse(
        res,
        (data) => {
          this.device = data.list?.find((d) => d._id === id) || {};
          this.getList(1, 100, this.device.name);
        },
        (error) => {}
      );
    });
  },

  watch: {
    project(newValue, oldValue) {
      if (newValue.id > 0) {
        this.getOtaListByProjectId(1, 100, newValue.id);
      }
    },
  },

  methods: {
    showVersion(v) {
      if (v) {
        if (this.isY001S) {
          return `${v}【${("00000000" + v)
            .substr(-8)
            .match(new RegExp(".{1,2}", "g"))
            .map((s) => parseInt("0x" + s))
            .join(".")}】`;
        }
        return this.isY006
          ? `${v}【${("00000000" + v)
              .substr(-8)
              .split("")
              .map((s, i) =>
                i == 0 ? "00" + s : i == 1 || i == 3 ? "0" + s : s
              )
              .join("")
              .match(new RegExp(".{1,3}", "g"))
              .map((s) => parseInt("0x" + s))
              .join(".")}】`
          : v;
      }
      return v;
    },
    projectChange(id) {
      this.project = this.projectList.find((p) => p.id === id) || {
        id: -1,
      };
      this.searchForm = { id: this.project.id };
    },
    getList(page, size, name) {
      getProjectList(page, size, name).then((response) => {
        handleResponse(
          response,
          (data) => {
            this.projectList = data.list;
            const id = this.$route.query.id * 1;
            this.project = this.projectList.find((p) => p.id === id) || {
              id: -1,
            };
            this.searchForm = { id: this.project.id };
          },
          (error) => {}
        );
      });
    },
    onOtaChange(scope) {
      this.otaChangeVisible = true;
      this.otaInfo = { ...scope.row };
    },
    modifyConfirm() {
      this.otaChangeVisible = false;
      this.getOtaListByProjectId(1, 100, this.project.id);
    },
    formatSocType(row) {
      let socTypeList = this.socTypeList;
      let soc = row.socType;
      return socTypeList[socTypeList.findIndex((item) => item.value == soc)]
        ?.name;
    },
    formatUpdate(row, column) {
      if (row.forceUpdate === 1) {
        return "强制更新";
      } else if (row.forceUpdate === 2) {
        return "建议更新";
      } else if (row.forceUpdate === 0) {
        return "无提示";
      }
      return "-";
    },

    successCreateNotifyAction() {
      this.closeOtaDialog();
    },

    close() {
      this.$refs.notifyForm.closeDialog();
    },

    sendMessage(index, rows) {
      this.selectedOtaVersion = Number(this.otaList[index]["version"]);
      this.selectedOtaId = this.otaList[index]["id"];
      this.sendMessageDialogVisible = true;
    },
    downloadFile(index, rows) {
      let fileName = this.otaList[index]["fileName"];
      getOtaFileUrl(fileName).then((response) => {
        handleResponse(
          response,
          (data) => {
            let url = data.url;
            if (url) {
              if (!url.startsWith("https")) {
                url = url.replace("http", "https");
              }
              window.open(url, "_self");
            } else {
              Message.error("下载地址不可用");
            }
            // window.location.href = url
          },
          (error) => {}
        );
      });
    },

    successCreateOtaAction() {
      this.otaDialogVisible = false;
      this.getOtaListByProjectId(1, 100, this.project.id);
    },
    submitVersion(index, rows) {
      let id = this.otaList[index].id;
      let version = this.otaList[index].version;
      if (version === this.submitVersionValue) {
        this.editVersionValue = "";
        this.submitVersionValue = "";
        return;
      }
      let data = {
        id: id,
        version: this.submitVersionValue,
      };

      editOta(data).then((response) => {
        handleResponse(
          response,
          (data) => {
            this.getOtaListByProjectId(1, 100, this.project.id);
          },
          (error) => {}
        );
      });
      this.editVersionValue = "";
    },

    editVersion(index, rows) {
      this.editVersionValue = this.otaList[index].version;
      this.submitVersionValue = this.otaList[index].version;
    },
    deleteOta(index, rows) {
      let id = this.otaList[index]["id"];

      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = { id: id };

          deleteOta(data).then((response) => {
            handleResponse(
              response,
              (data) => {
                this.getOtaListByProjectId(1, 100, this.project.id);
              },
              (error) => {}
            );
          });

          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    /**
     * 关闭弹出框 统一操作
     */
    closeOtaDialog() {
      this.otaDialogVisible = false;
      this.sendMessageDialogVisible = false;
    },
    /**
     * 上传OTA文件
     */
    uploadOtaFile() {
      this.otaDialogVisible = true;
    },
    getOtaListByProjectId(page, size, e) {
      if (e === null || e === "") {
        return;
      }
      getOtaList(page, size, e).then((response) => {
        handleResponse(
          response,
          (data) => {
            this.otaList = data.list;
          },
          (error) => {}
        );
      });
    },
  },
  data() {
    return {
      searchForm: {},
      device: {},
      projectList: [],
      project: { id: -1 },
      socTypeList: [
        {
          name: "01s",
          value: "0×00000001",
        },
        {
          name: "06s",
          value: "0×00000002",
        },
      ],
      otaDialogVisible: false,
      otaChangeVisible: false,
      otaInfo: {},
      submitVersionValue: "",
      editVersionValue: "",
      popVisible: true,
      otaList: [],
      sendMessageDialogVisible: false,
      selectedOtaId: -1,
      selectedOtaVersion: -1,
      y007Cols: [
        {
          label: "文件名",
          prop: "fileName",
        },
        {
          label: "文件大小",
          prop: "fileSize",
        },
        {
          label: "md5",
          prop: "validation",
        },
        {
          label: "上传时间",
          prop: "uploadTime",
        },
        {
          label: "上传人",
          prop: "uploadUser",
        },
      ],
    };
  },
};
</script>

<style scoped></style>
